import axios from './http'
// import axios from 'axios'

//设置默认超时时间
axios.defaults.timeout = 10000;

/**
 * 动态配置基本路径
 */

const api = {
    get(url, data) {
      return new Promise((resolve, reject) => {
        axios.get(url, {params: data})
          .then(res => {
            if (res.status === 200 && res.data.code === 200) { // 请求状态码
              resolve(res.data)
            } else {
              // res.data 没有值应该会触发catch
              if(res.data){
                reject(res.data)
              }else {
                reject(res);
              }

            }
          }).catch(res => {
          reject(res);

        }) // axios不加 catch  会输出错误
      });
    },

    delete(url, data) {
      return new Promise((resolve, reject) => {
        axios.delete(url, {params: data})
          .then(res => {
            if (res.status === 200 && res.data.code === 200) { // 请求状态码
              resolve(res.data)
            } else {
              // res.data 没有值应该会触发catch
              reject(res.data)
            }
          }).catch(res => {
          reject(res.data);
        }) // axios不加 catch  会输出错误
      });
    },

    //微信鉴权接口
    auth(url, data) {
      return new Promise((resolve, reject) => {
        axios.post(url, data)
          .then(res => {
            if (res.status === 200 ) { // 请求状态码
              resolve(res.data)
            } else {
              // res.data 没有值应该会触发catch
              reject(res.data)
            }
          }).catch(res => {
          reject(res.data);
        }) // axios不加 catch  会输出错误
      });
    },

    post(url, data) {
      return new Promise((resolve, reject) => {
        axios.post(url, data)
          .then(res => {
            if (res.status === 200 && res.data.code === 200) { // 请求状态码
              resolve(res.data)
            } else {
              // res.data 没有值应该会触发catch
              reject(res.data)
            }
          }).catch(res => {
          reject(res.data);
        }) // axios不加 catch  会输出错误
      });
    },
    post2(url, data) {
      return new Promise((resolve, reject) => {
        axios.post(url, {}, {params: data})
          .then(res => {
            if (res.status === 200 && res.data.code === 200) { // 请求状态码
              resolve(res.data)
            } else {
              // res.data 没有值应该会触发catch
              reject(res.data)
            }
          }).catch(res => {
          reject(res.data);
        }) // axios不加 catch  会输出错误
      });
    },

    put(url, data) {
      return new Promise((resolve, reject) => {
        axios.put(url, data)
          .then(res => {
            if (res.status === 200 && res.data.code === 200) { // 请求状态码
              resolve(res.data)
            } else {
              // res.data 没有值应该会触发catch
              reject(res.data)
            }
          }).catch(res => {
          reject(res.data);
        }) // axios不加 catch  会输出错误
      });
    },
  };
export {api}



// WEBPACK FOOTER //
// ./src/request/api.js